import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  deviceData: null,
  numOfDevices: 0,
  promise: null,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
